import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['range', 'field', 'track']
  static values = {
    min: { type: Number, default: 0 },
    max: Number,
    step: { type: Number, default: 1 }
  }

  connect () {
    this.syncFromRange()
    this.updateTrack()
  }

  syncFromRange () {
    if (!this.hasRangeTarget || !this.hasFieldTarget) return

    this.fieldTarget.value = this.rangeTarget.value
    this.updateTrack()
    this.publish(Number(this.rangeTarget.value))
  }

  syncFromField () {
    const value = this.clamp(this.fieldTarget.value, false)
    this.rangeTarget.value = String(value)
    this.updateTrack()
    this.publish(value)
  }

  commitField () {
    const value = this.clamp(this.fieldTarget.value, true)
    this.fieldTarget.value = String(value)
    this.rangeTarget.value = String(value)
    this.updateTrack()
    this.publish(value)
  }

  updateTrack () {
    if (!this.hasTrackTarget || !this.hasRangeTarget) return

    const min = this.minValue
    const max = this.hasMaxValue ? this.maxValue : min
    const value = Number(this.rangeTarget.value)
    const span = max - min
    const width = span === 0 ? 0 : ((value - min) / span) * 100

    this.trackTarget.style.width = `${width}%`
  }

  publish (value) {
    this.dispatch('change', { detail: { value } })
  }

  clamp (raw, snap) {
    const numeric = Number(raw)
    const min = this.minValue
    const max = this.hasMaxValue ? this.maxValue : numeric
    if (!Number.isFinite(numeric)) return min

    const bounded = Math.min(max, Math.max(min, numeric))
    if (!snap || this.stepValue <= 0) return bounded

    const snapped = Math.round(bounded / this.stepValue) * this.stepValue
    return Math.min(max, Math.max(min, snapped))
  }
}
